import { ButtonProps } from '@mui/material';
import { ApprovalAction, WithdrawalStatus } from '../@types/api';
import { APPROVAL_ACTION, WITHDRAWAL_STATUS } from './enums';

export type ApprovalActionConfig = {
  action: ApprovalAction;
  label: string;
  color: ButtonProps['color'];
  endpoint: string;
  successMessage: string;
  confirmationTitle: string;
};

const ACTION_CONFIGS: Record<ApprovalAction, Omit<ApprovalActionConfig, 'action'>> = {
  [APPROVAL_ACTION.APPROVE]: {
    label: 'Approve',
    color: 'success',
    endpoint: 'approve',
    successMessage: 'Transaction approved successfully.',
    confirmationTitle: 'Are you sure you want to approve this transaction?',
  },
  [APPROVAL_ACTION.REJECT]: {
    label: 'Reject',
    color: 'error',
    endpoint: 'reject',
    successMessage: 'Transaction rejected successfully.',
    confirmationTitle: 'Are you sure you want to reject this transaction?',
  },
  [APPROVAL_ACTION.COMPLETE]: {
    label: 'Complete',
    color: 'primary',
    endpoint: 'complete',
    successMessage: 'Transaction completed successfully.',
    confirmationTitle: 'Are you sure you want to complete this transaction?',
  },
};

const STATUS_ACTIONS: Record<WithdrawalStatus, ApprovalAction[]> = {
  [WITHDRAWAL_STATUS.PENDING]: [APPROVAL_ACTION.APPROVE, APPROVAL_ACTION.REJECT],
  [WITHDRAWAL_STATUS.REQUESTED]: [APPROVAL_ACTION.COMPLETE, APPROVAL_ACTION.REJECT],
  [WITHDRAWAL_STATUS.APPROVED]: [],
  [WITHDRAWAL_STATUS.REJECTED]: [],
};

export const getActionsForStatus = (status: WithdrawalStatus): ApprovalActionConfig[] => {
  const actions = STATUS_ACTIONS[status] || [];

  return actions.map((action) => ({
    action,
    ...ACTION_CONFIGS[action],
  }));
};
